import React, { useState } from 'react';
import { Box, useMediaQuery, useTheme, Tooltip } from '@mui/material';

const FloatingRobot: React.FC = () => {
  const [isHovered, setIsHovered] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (isMobile) return null;

  return (
    <Tooltip title="Interview My Official Digital Twin" placement="left" arrow>
      <a
        href="https://www.priyakant.live" // Replace with your actual link if needed
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: 'none' }}
        tabIndex={-1}
      >
        <Box
          sx={{
            position: 'fixed',
            bottom: 32,
            right: 32,
            zIndex: 1200,
            cursor: 'pointer',
            background: 'transparent',
            p: 0,
            transition: 'box-shadow 0.2s, transform 0.2s',
            boxShadow: isHovered
              ? '0 8px 32px 0 rgba(0,0,0,0.25), 0 1.5px 6px 0 rgba(0,0,0,0.15)'
              : '0 2px 8px 0 rgba(0,0,0,0.10)',
            transform: isHovered ? 'scale(1.10) rotate(-5deg)' : 'scale(1)',
            '&:hover': {},
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onFocus={() => setIsHovered(true)}
          onBlur={() => setIsHovered(false)}
          tabIndex={0}
          aria-label="Chat with RoboBot"
        >
          <Box
            component="img"
            src={isHovered ? '/roboFrontRedHatRaisedHand.png' : '/roboFrontRedHat.png'}
            alt="Floating Robot"
            sx={{
              width: 72,
              height: 'auto',
              maxHeight: 72,
              transition: 'transform 0.2s',
              transform: isHovered ? 'scale(1.08) rotate(-3deg)' : 'scale(1)',
              userSelect: 'none',
              display: 'block',
            }}
            draggable={false}
          />
        </Box>
      </a>
    </Tooltip>
  );
};

export default FloatingRobot; 